export default "__VITE_ASSET__d8e6e0dd__"